module.exports = __webpack_public_path__ + "e1d30d3b43cf8d9d48dc0ea775123932.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/reading-s.png
// module id = 1706
// module chunks = 0